import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'action-button',
    templateUrl: 'action-button.html'
})
export class ActionButtonComponent
{
    @Input() status: any;
    @Output() buttonClicked: EventEmitter<any> = new EventEmitter<any>();
    
    constructor()
    {
        console.log('Hello ActionButtonComponent Component');
    }
    
    public onClick()
    {
        this.buttonClicked.emit();
    }
}



// WEBPACK FOOTER //
// ./src/components/action-button/action-button.ts